const cardIcon = {
  visa: "cards/visa.svg",
  mastercard: "cards/mastercard.svg",
  amex: "cards/amex.svg",
  discover: "cards/discover.svg",
  jcb: "cards/jcb.svg",
  unionpay: "cards/unionpay.svg",
};

export { cardIcon };
